











































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
@Component
export default class Dwtz extends Vue {
    @Prop({ type: [Number, String]  })
    year?: number;
    name = "";
    code = "";
    newRow = {
        name: "",
        socialCreditCode: ""
    }
    dwList: any = []
    async fetchData() {
        const res = await Vue.axios.get(`gsnb/dwtzxx/get?accountBookId=${this.$store.state.accountBook.id}&year=${this.year}`);
        if (res) {
            this.dwList = res.data.data
        }
    }
    async del(item: any) {
        const res = await Vue.axios.delete(`gsnb/dwtzxx/delete?id=${item.id}`);
        this.fetchData()
    }
    async save(row:any) {
        const res = await Vue.axios.post(`gsnb/dwtzxx/save`, {
            id: row.id,
            accountBookId: this.$store.state.accountBook.id,
            year: this.year,
            name: row.name,
            socialCreditCode: row.socialCreditCode,
        });
        this.fetchData()

    }
    async addRow() {
        if (this.newRow.name != "" && this.newRow.socialCreditCode != "") {
            const res = await Vue.axios.post(`gsnb/dwtzxx/save`, {
                accountBookId: this.$store.state.accountBook.id,
                year: this.year,
                name: this.newRow.name,
                socialCreditCode: this.newRow.socialCreditCode,
            });
            this.newRow = {
                name: "",
                socialCreditCode: ""
            }
            this.fetchData()
        } else {
            this.$message({
                type: "warning",
                message: "请填写完整内容",
            });
        }
    }
    mounted() {
        this.fetchData()
    }
}
